<script setup>
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide }    from "swiper/vue";
import { useWindowSize } from "@vueuse/core";
import { ref, computed } from "vue";
import { useMainStore }  from "@/store/main";
import { AddPetButton }  from "./ui/Index";
import PetForm from "./Forms/PetForm.vue";
import 'swiper/css';

const emit = defineEmits();

const SwiperOptions = ref({
	modules       : [ Navigation, Pagination ],
	slidesPerView : 2,
	spaceBetween  : 18,
	navigation    : {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.pets-section__pagination',
	},
	breakpoints: {
		1440: {
			slidesPerView : 3,
		}
	}
})

const { formData } = useMainStore();

const { width } = useWindowSize();

const addPet = () => {
	formData.push({
		name   : '',
		drafts : [],
		photos : [],
	})
}

const hasDraft = computed(() => formData.some(el => 
	el.drafts.length &&
	!el.drafts.some(draft => !draft.time && !draft.comment)
));
</script>

<template>
	<div class="pets-section">
		<Swiper
			class="pets-section__swiper"
			v-if="width >= 768"
			v-bind="SwiperOptions"
		>
			<div class="pets-section__navigation">
				<button class="swiper-button-prev" aria-label="Предыдущая форма" />
				<button class="swiper-button-next" aria-label="Следующая форма" />
			</div>
			<SwiperSlide
				class="pets-section__slide"
				v-for="(_, index) in formData"
				:key="index"
			>
				<PetForm v-model="formData[index]" :cardId="index"/>
			</SwiperSlide>
			<SwiperSlide>
				<AddPetButton @addPet="addPet"/>
			</SwiperSlide>
			<div class="pets-section__pagination" />
		</Swiper>
		<div class="pets-section__content" v-else>
			<PetForm
				v-for="(_, index) in formData"
				v-model="formData[index]"
				:key="index"
				:cardId="index"
			/>
		</div>
		<AddPetButton
			v-if="width < 768"
			@addPet="addPet"
		/>
		<button
			class="long-btn"
			:disabled="!hasDraft"
			@click="emit('nextStep')"
		>Далее</button>
	</div>
</template>

<style lang="scss">
.pets-section {
	width: 100%;
	margin-top: 132px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
	padding-bottom: 100px;

	@include mq(560px) { padding-bottom: 0 }

	@include mq($tablet) { margin-top: 92px }

	@include mq($large) { margin-top: 20px }
}

.pets-section__swiper {
	width: 100%;
	overflow: visible;
}

.pets-section__content {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.pets-section__slide {
	height: 100%;

	&:first-child .pet__form::before {
		width: 188px;
		height: 131px;
		position: absolute;
		top: -112px;
		content: '';
		display: none;
		background-image: url('public/cat.png');
	}

	@include mq($tablet) {
		&:first-child .pet__form::before { display: block }
	}

	@include mq($large) {
		&:first-child .pet__form::before {
			width: 368px;
			height: 194px;
			left: 52px;
			top: -166px;
			background-image: url('public/cat2.png');
		}
	}
}

.swiper { position: relative }

.pets-section__navigation {
	position: absolute;
	top: -42px;
	right: 0;
	display: flex;
	align-items: center;
	gap: 22px;

	.swiper-button-prev svg { transform: rotate(180deg) }

	.swiper-button-disabled svg { color: #9D9E9E }

	.swiper-button-lock { display: none }

	button svg { color: $yellow }
}

.pets-section__pagination {
	margin-top: 12px;
	display: flex;
	gap: 8px;

	&.swiper-pagination-lock { display: none }

	.swiper-pagination-bullet {
		display: block;
		width: 6px;
		height: 6px;
		border-radius: 3px;
		transition: .3s;
		background-color: #E0E0E0;

		&-active {
			width: 18px;
			background-color: $yellow;
		}
	}
}
</style>
